import { render, staticRenderFns } from "./zhaoshangtupu.vue?vue&type=template&id=938970f8&scoped=true&"
import script from "./zhaoshangtupu.vue?vue&type=script&lang=js&"
export * from "./zhaoshangtupu.vue?vue&type=script&lang=js&"
import style0 from "./zhaoshangtupu.vue?vue&type=style&index=0&id=938970f8&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "938970f8",
  null
  
)

export default component.exports